angular.module('tgaAdmin')
  .service('divisionService', [
    '$http', 'envService', 'localStorageService', 'domainService', 'gameService',
    function (
      $http, envService, localStorageService, domainService, gameService,
    ) {
      const serverAddress = envService.read('serverAddress');
      let divisions = null;

      function destroy() {
        divisions = null;
      }

      function getDivision(division_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}division/${division_id}`,
          params: {
            domain: domainService.domain,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getDivisions(data, noCache) {
        data = data || {};
        data.domain = domainService.domain;

        if (noCache) {
          return $http({
            method: 'GET',
            url: `${serverAddress}division`,
            params: data,
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        if (!divisions) {
          divisions = $http({
            method: 'GET',
            url: `${serverAddress}division`,
            params: data,
          }).then(
            (response) => response.data,
            (error) => {
              throw error.data;
            },
          );
        }

        return divisions;
      }

      function addDivision(data) {
        divisions = null;
        gameService.destroy(); // clear games cache
        data.domain = domainService.domain;

        return $http({
          method: 'POST',
          url: `${serverAddress}division`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteDivision(division_id) {
        divisions = null;
        gameService.destroy(); // clear games cache

        return $http({
          method: 'DELETE',
          url: `${serverAddress}division/${division_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateDivision(data) {
        divisions = null;
        gameService.destroy(); // clear games cache
        data.domain = domainService.domain;

        return $http({
          method: 'PUT',
          url: `${serverAddress}division/${data.division_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        destroy,
        getDivision,
        getDivisions,
        addDivision,
        deleteDivision,
        updateDivision,
      });
    }]);
